<template>
  <div>
    <Hero>
      {{ $t('message.testDrive.pickRouteHeader') }}
      <img :src="require('@/assets/fa/automobile.svg')" width="22" height="22" class="mb-1 ml-1" alt="" />
      <template slot="description">{{ $t('message.testDrive.pickRouteDescription') }}</template>
    </Hero>
    <MobialisFormWithValidation v-slot="{ invalid, errors }" @onValidate="submit">
      <p class="error" v-if="invalid">
        {{ $t('message.testDrive.errorMessagePartOne') }}{{ $t('message.testDrive.errorMessagePartTwo')[3] }}
      </p>
      <RouteRadio
        :options="availableRoutes"
        v-model="chosenRoute"
        name="pick-route"
        error="$t('message.testDrive.pickRouteError')"
      />
      <div v-if="chosenRoute && chosenRoute !== 'custom_route'">
        <h4 class="mt-3 mb-0">{{ $t('message.testDrive.mapHeader') }}</h4>
        <div class="d-flex">
          <img :src="require('@/assets/fa/route.svg')" class="mr-2 mb-1" alt="" />
          <span class="sr-only">{{ $t('message.testDrive.routeType') }}</span>
          <p class="p-small text-muted">{{ routeTitle }}</p>
          <div class="vertical-line"></div>
          <img :src="require('@/assets/fa/clock-xsmall.svg')" class="mr-2 mb-1" alt="" />
          <span class="sr-only">{{ $t('message.testDrive.routeTime') }}</span>
          <p class="p-small text-muted">{{ mapTime }}</p>
          <div class="vertical-line" />
          <img :src="require('@/assets/fa/location.svg')" class="mr-2 mb-1" alt="" />
          <span class="sr-only">{{ $t('message.testDrive.routeDistance') }}</span>
          <p class="p-small text-muted">{{ mapDistance }}</p>
        </div>
        <img :src="mapUrl" class="map" :alt="$t('message.testDrive.map')" />
      </div>
      <mobialis-button class="cont-btn" type="submit" data-cy="continueBtn">
        {{ $t('message.common.continue') }}
      </mobialis-button>
    </MobialisFormWithValidation>
  </div>
</template>
<script>
import Hero from '@/components/test-drive/Hero.vue';
import RouteRadio from '@/components/test-drive/RouteRadio.vue';

export default {
  name: 'PickRoute',
  components: {
    Hero,
    RouteRadio,
  },
  data() {
    return {
      givenRoutes: [],
      routes: this.$t('message.testDrive.routePickTextArray'),
      customRoute: this.$t('message.testDrive.routePickTextArray[4]'),
      routeSettings: null,
      mapImageLink: '',
      mapTime: '',
      mapDistance: '',
      selectedRoute: null,
      mapUrl: null,
    };
  },
  computed: {
    availableRoutes() {
      const holder = this.routes.filter(item => this.givenRoutes.indexOf(item.value) !== -1);
      const holderLength = holder.length;
      if (this.isAVRMobile) {
        holder.push(this.customRoute);
      } else if (holderLength === 2) {
        holder.splice(holderLength - 1, 0, this.customRoute);
      } else if (holderLength === 4) {
        holder.splice(holderLength - 2, 0, this.customRoute);
      } else {
        holder.push(this.customRoute);
      }
      return holder;
    },
    routeTitle() {
      // This takes the lead info and converts it to a suitable format for the user.
      return this.$t('message.testDrive.routePickTextArray')[
        this.$t('message.testDrive.routePickTextArray')
          .map(a => a.value)
          .indexOf(this.chosenRoute)
      ].label
        ? this.$t('message.testDrive.routePickTextArray')[
            this.$t('message.testDrive.routePickTextArray')
              .map(a => a.value)
              .indexOf(this.chosenRoute)
          ].label
        : '';
    },
    chosenRoute: {
      get() {
        return this.$store.state.testDrive.chosenRoute;
      },
      set(value) {
        this.$store.commit('testDrive/SET_CHOSEN_ROUTE', value);
      },
    },
  },
  watch: {
    chosenRoute: {
      // everytime a new route is chosen, all of the data needs to be updated
      handler(val) {
        if (this.chosenRoute) {
          const indexOfSelected = this.routeSettings.map(a => a.name).indexOf(val);
          this.selectedRoute = this.routeSettings[indexOfSelected];
          if (indexOfSelected !== -1) {
            this.buildMapUrl();
            this.fillMapDetails();
          } else {
            this.mapImageLink = '';
            this.mapTime = '';
            this.mapDistance = '';
          }
        }
      },
    },
  },
  methods: {
    submit(isValid) {
      if (isValid) {
        this.$router.push({
          name: `drive-important-features-${this.baseRoute}`,
        });
      }
    },
    fillMapDetails() {
      // updates the values to be displayed above the map
      this.mapTime = this.selectedRoute.routeTime;
      this.mapDistance = this.selectedRoute.routeDistance;
    },
    buildMapUrl() {
      // takes parameters from the backend and constructs a url for the map image
      const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap?';
      const markerParam = `markers=${encodeURI(this.selectedRoute.originLocation.latitude)},${encodeURI(
        this.selectedRoute.destinationLocation.longitude
      )}`;
      const sizeParam = this.baseRoute === 'desktop' ? 'size=725x248' : 'size=375x225';
      const scaleParam = 'scale=4';
      const pathParam = `path=color:694fc1|weight:5|enc:${encodeURI(this.selectedRoute.encodedPolyline)}`;
      const apiKeyParam = `key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`;
      this.mapUrl = `${baseUrl}${sizeParam}&${scaleParam}&${markerParam}&${pathParam}&${apiKeyParam}`;
    },
  },
  async created() {
    this.routeSettings = this.$store.state.testDrive.settings.testDriveRoutes;
    this.givenRoutes = this.routeSettings.map(a => a.name);
    if (this.chosenRoute) {
      const indexOfSelected = this.routeSettings.map(a => a.name).indexOf(this.chosenRoute);
      if (indexOfSelected > -1) {
        this.selectedRoute = this.routeSettings[indexOfSelected];
        this.buildMapUrl();
        this.fillMapDetails(indexOfSelected);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.cont-btn {
  margin-top: 40px;
}
.map {
  max-width: 100%;
  height: auto;
}
.vertical-line {
  border: 1px solid rgb(205, 205, 205);
  height: 20px;
  margin-left: 27px;
  margin-right: 27px;
  margin-top: 12px;
}
@media (min-width: $breakpoint-mobile) {
  .cont-btn {
    margin-top: 50px;
  }
}
</style>
